<template>
  <div>
    <div class="web1">
      <div class="outterBox">
        <div class="topHeader">
          <span>일자 선택</span>
          <span class="headerDetailText text-warning">※ 매월 3번째 수요일 정기 휴장</span>
        </div>
        <div class="top">
          <div class="dateColumn">
            <DatePicker
              is-expanded
              ref="cal"
              :value="selectedDate"
              v-model="selectedDate"
              color="red"
              :columns="layout.columns"
              :rows="layout.rows"
              :step="1"
              :available-dates="availableDates"
              :attributes="attrs"
              :disabled-dates="disabledDates"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import reserveService from '@/services/rev.service';
import Calendar from 'v-calendar/lib/components/calendar.umd';
import DatePicker from 'v-calendar/lib/components/date-picker.umd';
import {DateUtil} from '@/util/DateUtil';
import GeneralUtil from '@/util/GeneralUtil';

// export type GolfListType = 'RECEIPT' | 'WAIT' | 'REAL';

export default {
  name: 'GolfDatePicker',
  mixins: [GeneralUtil],
  components: {
    DatePicker,
  },
  props: {
    listType: String,
    revConfirmList: Array,
  },
  data() {
    return {
      selectedDate: null,
      golfDateList: [],
      availableDates: [],
      disabledDates: {weekdays: [1, 2, 3, 4, 5, 6, 7]},
      attrs: [],
      row: 1,
      col: 1,
    };
  },
  watch: {
    listType(newVal, oldVal) {
      this.refreshCalGrid();
      this.updateAvailDates();
    },
    selectedDate(newVal, oldVal) {
      if (newVal) {
        // 날짜 선택 즉시 티오프 로딩 시작
        this.$EventBus.$emit('TeeOffLoadingStart');
        this.$EventBus.$emit('RevDateChanged', newVal);
      }
    },
  },
  computed: {
    layout() {
      return this.$screens({
        // Default layout for mobile
        default: {
          columns: 1,
          rows: 1,
        },
        // Override for large screens
        sm: {
          columns: 2,
          rows: 1,
        },
      });
    },
    year() {
      return DateUtil.getYearString(this.selectedDate);
    },
    month() {
      return DateUtil.getMonthString(this.selectedDate);
    },
    day() {
      return DateUtil.getDayString(this.selectedDate);
    },
  },
  created() {
    this.refreshCalGrid();
    this.updateAvailDates();
    this.$EventBus.$on('UpdateDot', this.refreshDot);
  },
  beforeDestroy() {
    this.$EventBus.$off('UpdateDot', this.refreshDot);
  },

  methods: {
    refreshCalGrid() {
      if (this.listType !== 'REAL') {
        this.col = 2;
        this.row = 1;
      } else {
        this.col = 1;
        this.row = 2;
      }
    },
    refreshDot() {
      this.attrs = [];
      let existDate = [];
      this.revConfirmList.map(x => {
        this.availableDates.map(y => {
          if (moment(x.selectedDate).format('YYYYMMDD') === moment(y).format('YYYYMMDD')) {
            existDate.push(y);
          }
        });
      });

      this.attrs = [
        {
          dot: 'red',
          dates: existDate,
        },
      ];

      console.log('====', this.attrs);

      // {
      //   dot: 'red',
      //     dates: {
      //   start: new Date('1/1/2018'),
      //     monthlyInterval: 2, // Every other month
      //     ordinalWeekdays: {[-1]: 6}, // ...on the last Friday
      // },
      // },
    },
    async updateAvailDates() {
      // let t1 = GolfListType.RE
      let selectedMember = this.$store.getters['Auth/selectedMember'];
      let aList = await reserveService.getDateList(this.listType, selectedMember.memNo);

      // 3000 에러 debug용
      // aList = {
      //   resultCode: '3000',
      //   msg: '조회된 정보가 없습니다.',
      //   items: [],
      //   obj: null,
      // };

      if (aList.resultCode === '0000') {
        this.golfDateList = aList.items;

        if (this.golfDateList.length > 0) {
          let firstDate = this.golfDateList[0];
          this.selectedDate = moment(firstDate['bookDate'], 'YYYYMMDD').format('YYYY-MM-DD');
        }

        console.log('golfDateList', this.golfDateList);

        // 캘린터 활성화 일자
        this.availableDates = [];
        // YYYYMMDD -> Date
        //잔여접수는 7주전 화요일부터 내장일 2일전까지만 예약가능
        const maxDate = moment().add(35, 'days');
        const minDate = moment().add(2, 'days');
        console.log('minDate', minDate.format('YYYYMMDD'));
        console.log('maxDate', maxDate.format('YYYYMMDD'));
        this.golfDateList.forEach(x => {
          let str = x['bookDate'];
          let y = str.substr(0, 4);
          let m = str.substr(4, 2);
          let d = str.substr(6, 2);
          if (this.listType === 'WAIT') {
            // const checkDate = moment(str, 'YYYYMMDD');
            // if (checkDate.isBetween(minDate, maxDate, 'day', '[]')) {
            //   console.log('checkDatestr', str);
            //   this.availableDates.push(new Date(y, m - 1, d));
            // }
            this.availableDates.push(new Date(y, m - 1, d));
          } else {
            this.availableDates.push(new Date(y, m - 1, d));
          }
        });
        this.selectedDate = this.availableDates[0];
        await this.$refs.cal.move(this.selectedDate);
        this.disabledDates = [];
        console.log(this.selectedDate);
      } else {
        this.disabledDates = {weekdays: [1, 2, 3, 4, 5, 6, 7]};
        this.showMsgBoxOkPmsErr(aList.msg);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.outterBox {
  border: 0px solid #6e6e6e;
}

.topHeader {
  display: flex;
  flex-direction: column;
  padding-top: 1rem;
  padding-left: 2rem;
  font-weight: bold;
  font-size: 1.3rem;
  .headerDetailText {
    font-size: 0.8rem;
    font-weight: 500;
    line-height: 1.3;
    color: #999999;
    margin-top: 0.3rem;
  }
}
.top {
  display: flex;
  padding: 1rem;
}

.dateColumn {
  width: 100%;
  padding: 0.3rem;
}
.calenderItem1 {
  padding: 0rem;
}
.calenderItem2 {
  padding: 0rem;
}
.web1 {
  margin: 0;
  padding: 0;
  .col {
    font-size: 0.9rem;
  }
  .row {
    font-size: 0.9rem;
  }
}

@media (max-width: 992px) {
  hr {
    margin: 0px;
  }
  .web1 {
    display: block;
    .col {
      font-size: 0.9rem;
    }
    .row {
      font-size: 0.9rem;
    }
  }
  .topHeader {
    padding-top: 0rem;
    padding-left: 1rem;
    font-weight: bold;
    font-size: 1.3rem;
    .subinfo {
      font-size: 0.7rem;
      line-height: 1.3;
      color: #727272;
      margin-top: 0.3rem;
    }
  }
  .top {
    display: flex;
    padding: 0rem;
  }
}
::v-deep .vc-container {
  --orange-100: red !important;
  --orange-200: #af8c5e !important;
  --orange-300: #af8c5e !important;
  --orange-400: #af8c5e !important;
  --orange-500: #af8c5e !important;
  --orange-600: #af8c5e !important;
  --orange-700: #af8c5e !important;
  --orange-800: #af8c5e !important;
  --orange-900: white !important;
  border: 0 !important;
}

::v-deep .vc-highlight {
  background-color: #af8c5e !important;
}
</style>
